import React, { useEffect, useState } from "react";

import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

function SupportRecentActivity({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const navigate = useNavigate();
  const [timeSpent, setTimeSpent] = useState({});
  const [messages, setMessages] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [supportMembers, setsupportMembers] = useState([]);

  const getTickets = async () => {
    try {
      let payload = {};

      payload = {
        ...inputData,
      };
      setLoader(true);
      const resp = await api.getSupportRecentActivity(payload);
      // console.log(resp);
      if (resp?.success) {
        setMessages(resp?.recentMessages || []);
        setSessions(resp?.recentSessions || []);
        setTickets(resp?.recentTickets || []);
        setTimeSpent(resp?.timeSpent || {});
      }
      // setData(userData.tickets);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleReset = () => {
    setInputData({});
    setMessages([]);
    setSessions([]);
    setTickets([]);
  };

  const getSupport = async () => {
    try {
      setLoader(true);
      const res = await api.getSupportAdmin();
      // console.log(res);
      if (res?.success) {
        setsupportMembers(res.support);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSupport();
  }, []);

  useEffect(() => {
    if (inputData?.adminId) {
      getTickets();
    }
  }, [inputData]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}

        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Support Recent Activity
                </h4>
              </div>
            </div>
            <div className="SupportfilterM row mx-0">
              <div className="col-12">
                <div className="fRow">
                  <div className="me-3">Select Support:</div>

                  <div className="form-group my-3 me-3 position-relative">
                    <i className="fa-solid fa-caret-down  arrowDownIco" />

                    <select
                      name="support"
                      id=""
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          adminId: e.target.value,
                        })
                      }
                      value={inputData?.adminId}
                      className="form-control ng-dirty ng-invalid ng-touched"
                    >
                      <option value="">Select Support</option>
                      {supportMembers.map((val, key) => (
                        <option
                          key={key}
                          value={val?._id}
                          selected={
                            inputData?.adminId == val?._id ? true : false
                          }
                        >
                          {val?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button
                    className="themeBlackBtn"
                    onClick={() => handleReset()}
                  >
                    Reset Filter
                  </button>
                </div>
              </div>
            </div>

            <div className="row analytics-row mt-3">
              <AnalyticsBox
                icon={<i className="fa-solid fa-clock"></i>}
                title="Spent Today"
                amount={timeSpent?.today || 0}
              />
              <AnalyticsBox
                icon={<i className="fa-solid fa-clock"></i>}
                title="Spent last 7 Days"
                amount={timeSpent?.last7Days || 0}
              />
              <AnalyticsBox
                icon={<i className="fa-solid fa-clock"></i>}
                title="Spent This Month"
                amount={timeSpent?.thisMonth || 0}
              />
            </div>
            {/* table */}
            <TableSessions data={sessions} />
            <Table data={tickets} />
            <TableMessage data={messages} />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const navigate = useNavigate();

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>Recent Ticket Process</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Issue ID
                  </th>

                  <th scope="col" className="">
                    User Email
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                  <th scope="col" className="">
                    Issue Type
                  </th>
                  <th scope="col" className="">
                    Updated At
                  </th>
                  <th scope="col" className="">
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.issueId}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.userId?.email}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          item?.status == "pending"
                            ? "red table-text-dark w-max-c db"
                            : item?.status == "processing"
                            ? " yellow table-text-dark w-max-c db"
                            : "green table-text-dark w-max-c db"
                        }
                      >
                        {item?.status}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.issueType}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.updatedAt)}
                      </span>
                    </td>

                    <td>
                      <i
                        className="fa-solid fa-eye cursor-pointer"
                        onClick={() =>
                          navigate(`/admin/support/ticket/${item?.issueId}`)
                        }
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const TableSessions = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const navigate = useNavigate();

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  function formatMinutesToHours(minutes) {
    if (typeof minutes !== "number" || isNaN(minutes)) return "0 min";

    if (minutes < 60) {
      return `${minutes} min`;
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      if (remainingMinutes === 0) {
        return `${hours} hr${hours > 1 ? "s" : ""}`;
      } else {
        return `${hours} hr${hours > 1 ? "s" : ""} ${remainingMinutes} min`;
      }
    }
  }

  return (
    <>
      <div className="card sortby-box br-10 border-transparent ">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>Recent Sessions</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Login Time
                  </th>

                  <th scope="col" className="">
                    Logout Time
                  </th>
                  <th scope="col" className="">
                    Duration
                  </th>
                  <th scope="col" className="">
                    Active
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.loginTime)}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.logoutTime)}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatMinutesToHours(item?.duration)}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          item?.active
                            ? "green table-text-dark w-max-c db"
                            : "red table-text-dark w-max-c db"
                        }
                      >
                        {item?.active ? "Online" : "Offline"}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const TableMessage = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const navigate = useNavigate();

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>Recent Message Sent</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Issue Id
                  </th>
                  <th scope="col" className="">
                    Issue Type
                  </th>
                  <th scope="col" className="">
                    Message
                  </th>
                  <th scope="col" className="">
                    Timestamp
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.issueId}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.issueType}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.message,
                          }}
                        />
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.timestamp)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal">
                <img className="w-100" src={activeImg} alt="" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

function AnalyticsBox(props) {
  return (
    <div className="col-xl-4 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10 ">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              {/* <img className="analytic-box-img" src={props.icon} alt="" /> */}
              <div className="analytic-box-img">{props.icon}</div>
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold  mb-1">
                <span className="analytics-box-title">{props.title}</span>
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {props.amount}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportRecentActivity;
